export enum RoutesOption {
  Home = "/",
  HomeWithNew = "/?new",
  New = "/new",
  Shared = "/shared/:noteId",
}
